<template>
  <div class="c-TabsContainer" data-component="TabsContainer">
    <div class="nav">
      <template v-for="(tab, index) in props.tabs" :key="tab.id">
        <label>
          <input
              type="radio"
              :name="name"
              :value="tab.id"
              v-model="selectedTabId"
          >
          <span>{{tab.label ?? tab.id}}</span>
        </label>
        <span v-if="index < props.tabs.length - 1" class="divider"> | </span>
      </template>
    </div>
    <hr>
    <template v-if="selectedComponent">
      <div class="content keep-alive" v-if="keepAlive">
        <KeepAlive>
          <component
              :is="selectedComponent"
              :key="selectedTabId"
              v-bind="selectedTabProps"
          />
        </KeepAlive>
      </div>
      <div class="content" v-else>
        <component
            :is="selectedComponent"
            :key="selectedTabId"
            v-bind="selectedTabProps"
        />
      </div>
    </template>
    <div class="content no-component" v-else></div>
  </div>
</template>

<script setup lang="ts">
import {type Component, computed, watchEffect} from "vue";
import type {TabItem} from "./tabs-helper.ts";
export type {TabItem};

const props = withDefaults(defineProps<{
  tabs:  TabItem[],
  // to group all "radio" inputs
  name?: string;
  keepAlive?: boolean;
}>(), {
  keepAlive: false,
});
const name = computed(() => props.name ?? `tabs-group-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);

const selectedTab = computed<TabItem | undefined>(() => {
  return props.tabs.find(tab => tab.id === selectedTabId.value);
});
const selectedComponent = computed<Component | undefined>(() => {
  return selectedTab.value?.component;
});

const selectedTabId = defineModel<string>("selectedTabId", {
  default: ""
});
watchEffect(() => {
  if (props.tabs.length === 0) {
    selectedTabId.value = "";
    return;
  }
  if (!selectedTab.value) {
    selectedTabId.value = props.tabs[0].id;
  }
});
const selectedTabProps = computed(() => selectedTab.value?.props);
</script>
